import { css, type Theme } from "@emotion/react";

const panelColumnWidth = "41.2%";
const formColumnMaxWidth = "880px";
const logoWidth = "190px";

export const fullBleedRow = css`
  display: flex;
  align-items: stretch;
  height: 100%;
`;

export const panelPlaceholder = css`
  width: 100%;
  height: 100%;
`;

export const panelColumn = css`
  flex: 0 0 ${panelColumnWidth};
  max-width: ${panelColumnWidth};
`;

export const formColumn = (theme: Theme) => css`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: ${theme.ds5.spacing.gap.large};
`;

export const formColumnInner = css`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  max-width: ${formColumnMaxWidth};
  margin: 0 auto;
`;

export const countrySelectRow = (theme: Theme) => css`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${theme.ds5.spacing.gap.small};
`;

export const logoContainer = (theme: Theme) => css`
  display: flex;
  justify-content: center;
  padding: ${theme.ds5.spacing.gap.xlarge} 0;
`;

export const logo = css`
  width: ${logoWidth};
  height: auto;
`;

export const formContent = css`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const formGroup = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
